import { BarChartOutlined, CalendarOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Collapse, Modal, Tooltip, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { redirect, useLoaderData } from 'react-router-dom';
import { getCombiQuotationDetails, sendCombinedPrices, visualReceived } from '../../api/vendor/vendorQuotation';
import { Steps } from '../../components/Steps';
import { CombiQuotationDetailsSection } from '../../components/data/quotation/quotation-details';
import { Box } from '../../components/design';
import { Page } from '../../components/page';
import { generateRouteUrl } from '../../library/constants';
import { CombiQuotationSteps } from '../../library/constants/quotation-steps-combi';
import { convertDateFormat } from '../../library/helpers/dateFormat';
import style from './quotation-details.module.scss';
import CombiQuotationLogs from './tasks/combi-quotation-logs';
const { Panel } = Collapse;

const getStepCompoment = (status) => CombiQuotationSteps.find(s => s.status === status)?.component()
function checkStatus(quoatationData) {
	return (quoatationData.vendorData.status)
}

export const formDataToJson = (formData) => {
	return Object.entries(formData).reduce((json, [key, value]) => {
		const matches = key.match(/(\w+)\[(\d+)\]/);
		if (matches) {
			const [, parentKey, childKey] = matches;
			json[parentKey] = json[parentKey] || {};
			json[parentKey][childKey] = value;
		} else {
			const matches2 = key.match(/\[(\d+)\](\w+)/);
			if (matches2) {
				const [, parentKey, childKey] = matches2;
				json[parentKey] = json[parentKey] || {};
				json[parentKey][childKey] = value;
			}
			else {
				json[key] = value;
			}
		}
		return json;
	}, {});
}

const CombiQuotationDetails = () => {
	const { quoatationData } = useLoaderData({});
	const [current, setCurrent] = useState(checkStatus(quoatationData))
	useEffect(() => {
		setCurrent(quoatationData.vendorData.status)
	}, [quoatationData.vendorData.status])
	const CurrentComponent = getStepCompoment(current)
	return (
		<Page title={"Combi Quotation Details"}>
			{quoatationData.item != null ?
				<div className={style.gap}>
					<div className={style.grid}>
						<Collapse defaultActiveKey={['1']} expandIconPosition="end">
							<Panel header={quoatationData.item.product.name} key="1">
								<CombiQuotationDetailsSection detail={quoatationData} comment={quoatationData.item.vendor_comment} />
							</Panel>
						</Collapse>
						<Collapse defaultActiveKey={['1']} expandIconPosition="end">
							<Panel header={<><img src="/icons/iteminformation.svg" style={{ width: '1rem', verticalAlign: 'sub', marginRight: '8px' }} />Item Information</>} key="1" >
								<div className={`box--white ${style.projectItem}`}>
									<div className={style.itemDates}>
										<BarChartOutlined className={style.icons} />
										<div>
											Project ID <br />
											<span className={style.date}>
												{quoatationData?.vendorData?.global_project_id}
											</span>
										</div>
									</div>
									<div className={style.itemDates}>
										<BarChartOutlined className={style.icons} />
										<div>
											Quantity <br />
											<span className={style.date}>{
												quoatationData.vendorData?.item_vendor_quotation_prices?.length > 0
													? quoatationData.vendorData.item_vendor_quotation_prices.map(p => p.quantity).join(', ')
													: (Array.isArray(quoatationData.item?.quantities) ? quoatationData.item.quantities.join(', ') : quoatationData.item?.quantities?.toString() || '')
											}</span>
										</div>
									</div>
									<div className={style.itemDates}>
										<CalendarOutlined className={style.icons} />
										<div>
											Quotation Date <br />
											<span className={style.date}>{convertDateFormat(quoatationData.vendorData.createdAt)}</span>
										</div>
									</div>
									<div className={style.itemDates}>
										<CalendarOutlined className={style.icons} />
										<div>
											Submit Quotation By <br />
											<span className={style.date}>{convertDateFormat(quoatationData.vendorData.createdAt)}</span>
										</div>
									</div>
									{quoatationData.item.client_expected_delivery_date && <div className={style.itemDates}>
										<CalendarOutlined className={style.icons} />
										<div>
										<Tooltip title="The estimated date for the delivery to be completed.">
											<span>Deadline Delivery Date <InfoCircleOutlined /></span>
										</Tooltip>
										<br />
										<Tooltip title="The estimated date for the delivery to be completed.">
											<span className={style.date}>{convertDateFormat(quoatationData.item.client_expected_delivery_date)}</span>
										</Tooltip>
										</div>
									</div>}
									{/* <div className={style.itemDates}>
										<PushpinOutlined className={style.icons} />
										<div>
											Delivery Location <br />
											<span className={style.date}>{<span className={style.cardValue}>{
												quoatationData.item.delivery_type == 3 ? 'Bulk' : quoatationData?.countries.toString()
											} </span>}</span>
										</div>
									</div> */}
								</div>
							</Panel>
						</Collapse>
					</div>
					{quoatationData.vendorData?.request_comment && <Box type={Box.BoxTypes.MEDIUM}>
						<h4>Special Comment : {quoatationData.vendorData?.request_comment}</h4>
					</Box>}
					<div className={style.stepsContainer}>
						<Steps
							currentStep={current}
							items={CombiQuotationSteps}
						/>
						<div className={style.stepBody}>
							<CurrentComponent />
						</div>
					</div>
					<CombiQuotationLogs logs={quoatationData.item_vendor_quotations} active={quoatationData?.vendorData}></CombiQuotationLogs>
				</div> : <div>
					<Alert message="Item Does not Esist" description='The quotation that you wanted to view is either cancelled or removed form the system' />
				</div>
			}
		</Page>
	)
}
CombiQuotationDetails.Actions = {
	sendQuotation: async ({ data }) => {
		const { comment, itemId, ...quoatationData } = data
		//console.log(data);
		const payload = {
			data: Object.values(formDataToJson(quoatationData)).map((row) => ({
				quantity: parseInt(row.quantity),
				expected_artwork_received_date: row.expected_artwork_received_date == "" ? null : row.expected_artwork_received_date,
				purchase_price: parseFloat(String(row.purchase_price).replace(",", ".")),
				shipping_cost: parseFloat(String(row.shipping_cost).replace(",", "."))
			})),
			comment
		}
		let flag = 0;
		payload.data.forEach((e) => {
			if (e.purchase_price == 0) {
				flag = 1
				return 0
			}
		})
		if (flag == 1) {
			message.error('Purchase price cannot be zero')
		}
		else {

			try {
				const response = await sendCombinedPrices(itemId, payload)
				const { message: msg } = response
				message.success(msg);
			}
			catch (error) {
				message.error(error.message)
				if (error.message == "Changes in the quotation, please refresh the page.") {
					window.location.reload()
				}
			}
		}
		return true
	}
}
CombiQuotationDetails.Loader = async ({ params }) => {
	if (isNaN(params.id)) {
		throw new Error('Invalid Quotation ID')
	}
	const quoatationData = await getCombiQuotationDetails(params.id)
	if (!quoatationData) {
		throw new Error('Invalid Quoation')
	}
	const visualData = await visualReceived(quoatationData.vendorData.id)
	if (quoatationData?.active_vendor_quotation_id != params.id && quoatationData?.active_vendor_quotation_id != null) {
		Modal.warning({
			title: 'Quotation is Outdated',
			content: (
				<div>
					<p>Previous Quotation has been cancelled, we are redirecting to you to new quotation</p>
				</div>
			),
			onOk() {
				Modal.destroyAll();
			}
		});
		return redirect(generateRouteUrl('CombiQuotationDetails', { id: quoatationData?.active_vendor_quotation_id }));

	}
	// if (!visualData) {
	// 	throw new Error('Invalid Visaul Data')
	// }
	// setCurrent(checkStatus(quoatationData))
	// const basicquotationDetails = (({
	// 	vendorData, item, specifications
	// }) => ({
	// 	vendorData, item, specifications
	// }))(quoatationData)
	return { quoatationData, visualData }
}

CombiQuotationDetails.propTypes = {
	title: PropTypes.string
}

export default CombiQuotationDetails;
